import { render, staticRenderFns } from "./ZTab.vue?vue&type=template&id=4ded996c&"
import script from "./ZTab.vue?vue&type=script&lang=js&"
export * from "./ZTab.vue?vue&type=script&lang=js&"
import style0 from "./ZTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports